import { PREVIEW_ID } from '../../utils/constants';

export function disableChildIframesPointerEvents(
  previewDocument = document.getElementById(PREVIEW_ID).contentDocument,
) {
  previewDocument
    .querySelectorAll('iframe')
    .forEach(frameElement => (frameElement.style.pointerEvents = 'none'));
}

export function enableChildIframesPointerEvents(
  previewDocument = document.getElementById(PREVIEW_ID).contentDocument,
) {
  previewDocument
    .querySelectorAll('iframe')
    .forEach(frameElement => (frameElement.style.pointerEvents = 'auto'));
}

export function scrollTo(x, y) {
  document.getElementById(PREVIEW_ID).contentWindow.scrollTo({
    left: x,
    top: y,
    behavior: 'smooth',
    block: 'start',
  });
}

export function getScrollOffset(
  previewFrame = document.getElementById(PREVIEW_ID),
) {
  return (
    previewFrame.contentWindow.innerWidth -
    previewFrame.contentDocument.body.offsetWidth
  );
}
